import React from 'react'
import { Box, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 1280,
    width: '100%',
    marginBottom: 50,
    color: '#002f3d'
  },
  homePageHeader: {
    fontSize: 28,
    fontWeight: 400,
    marginTop: 20,
    marginLeft: 10
  },
  titleItemContainer: {
    margin: '15px 10px'
  },
  titleImageContainer: {
    height: 230,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  },
  titleTextContainer: {
    padding: '10px 20px',
    background: 'white'
  },
  titleText: {
    display: 'block',
    fontWeight: 400,
    fontSize: 24,
    lineHeight: '32px'
  },
  subTitleText: {
    display: 'block',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 1.45
  }
}))

const TitleList = () => {
  const classes = useStyles()

  const {
    sectionTitle,
    a1Link,
    a1Title,
    a1Caption,
    a1Picture,
    a2Link,
    a2Title,
    a2Caption,
    a2Picture,
    a3Link,
    a3Title,
    a3Caption,
    a3Picture
  } = useSelector(state => state.language.text)

  const contents = [
    {
      imageSource: a1Picture,
      title: a1Title,
      subTitle: a1Caption,
      link: a1Link
    },
    {
      imageSource: a2Picture,
      title: a2Title,
      subTitle: a2Caption,
      link: a2Link
    },
    {
      imageSource: a3Picture,
      title: a3Title,
      subTitle: a3Caption,
      link: a3Link
    }
  ]
  return (
    <>
      <Grid container justify="center" spacing={0}>
        <Grid item className={classes.container}>
          <Grid
            container
            alignItems="flex-start"
            justify="flex-start"
            spacing={0}>
            <Grid item xs={12} className={classes.homePageHeader}>
              {sectionTitle}
            </Grid>

            {contents.map(({ imageSource, title, subTitle, link }) => (
              <Grid key={title} item xs={12} sm={6} md={4}>
                <a href={link}>
                  <Box className={classes.titleItemContainer}>
                    <Box
                      className={classes.titleImageContainer}
                      style={{ backgroundImage: `url(${imageSource})` }}></Box>
                    <Box className={classes.titleTextContainer}>
                      <span className={classes.titleText}> {title}</span>
                      <span className={classes.subTitleText}> {subTitle}</span>
                    </Box>
                  </Box>
                </a>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default TitleList
